import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

export const SubscribersTable = ({ subs }) => (
  <div className="border border-olive/30 bg-cream">
    <Table>
      <TableHeader>
        <TableRow className="border-olive/30 hover:bg-transparent">
          <TableHead className="text-charcoal/70">Email</TableHead>
          <TableHead className="text-charcoal/70 text-right">Joined</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {subs.length === 0 ? (
          <TableRow>
            <TableCell colSpan={2} className="font-body text-charcoal/60 py-8 text-center">
              No subscribers yet.
            </TableCell>
          </TableRow>
        ) : (
          subs.map((s) => (
            <TableRow key={s.id} data-testid={`subscriber-row-${s.id}`} className="border-olive/20">
              <TableCell className="font-body text-charcoal">{s.email}</TableCell>
              <TableCell className="font-body text-charcoal/60 text-right">
                {s.created_at ? new Date(s.created_at).toLocaleDateString() : "—"}
              </TableCell>
            </TableRow>
          ))
        )}
      </TableBody>
    </Table>
  </div>
);
